import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable, tap, throwError } from 'rxjs'
import { getEndpoint } from '@app/utils/get-endpoint'
import { Contact } from '@app/models/contact'
import { DoesQuoteExistResponse } from '@app/models/does-quote-exist-response.model'

type TSFixMe = any

@Injectable({
	providedIn: 'root',
})
export class QuoteService {
	#account: string = 'Account'
	#quote: string = 'Quote'

	constructor(private readonly http: HttpClient) {}

	public getStateGivenZip(zip: string): Observable<string> {
		// FIXME: Fix this type
		return this.http
			.post(
				getEndpoint([this.#account, 'GetStateGivenZip']),
				{ ZipCode: zip },
				{ responseType: 'text' }
			)
			.pipe(
				catchError((err) => {
					// let errorMessage: string = err?.error
					// 	? JSON.parse(err.error)
					// 	: 'There was an error'
					err.error ||= 'There was an error'

					return throwError(() => err.error)
				})
			)
	}

	public doesQuoteExist(contact: Contact): Observable<DoesQuoteExistResponse> {
		return this.http.post<DoesQuoteExistResponse>(
			getEndpoint([this.#quote, 'DoesQuoteExists']),
			contact
		)
	}
}
